var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _rect9, _rect10, _rect11, _path, _path2, _line10, _line11, _line12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpCatalogPresentationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.f{fill:none;}.b{fill:#3c3c46;opacity:0.2;}.c{fill:#e5e5e5;}.c,.f,.g,.h,.i,.j{stroke:#3c3c46;stroke-linecap:round;stroke-linejoin:round;}.c,.f,.h,.i,.j{stroke-width:2px;}.d{fill:#ffefe0;}.e{fill:#fff;}.g,.h,.j{fill:#89d9fb;}.g{stroke-width:2px;}.i{fill:#3ca4ef;}.i,.j{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-presentation-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 33,
    y: 13.02,
    width: 80,
    height: 119.96
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 27,
    y: 123.11,
    width: 80,
    height: 3.87
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 27,
    y: 119.24,
    width: 80,
    height: 3.87
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 67,
    y: 63.13,
    width: 40,
    height: 56.11
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 27,
    y: 63.13,
    width: 40,
    height: 56.11
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 27,
    y: 63.13,
    width: 80,
    height: 56.11
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 27,
    y: 7.02,
    width: 80,
    height: 56.11
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 89.91,
    y1: 67.97,
    x2: 89.91,
    y2: 58.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 82.28,
    y1: 67.97,
    x2: 82.28,
    y2: 58.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 74.64,
    y1: 67.97,
    x2: 74.64,
    y2: 58.3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 67,
    y1: 67.97,
    x2: 67,
    y2: 58.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 59.36,
    y1: 67.97,
    x2: 59.36,
    y2: 58.3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 51.72,
    y1: 67.97,
    x2: 51.72,
    y2: 58.3
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 44.09,
    y1: 67.97,
    x2: 44.09,
    y2: 58.3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 36.45,
    y1: 67.97,
    x2: 36.45,
    y2: 58.3
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 97.55,
    y1: 67.97,
    x2: 97.55,
    y2: 58.3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 76.27,
    y: 84.14,
    width: 4.67,
    height: 8.31
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 84.66,
    y: 81.88,
    width: 4.67,
    height: 10.57
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 93.06,
    y: 75.46,
    width: 4.67,
    height: 16.99
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M47,91.19l11.26,6.5A13,13,0,1,1,47,78.19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M47,91.19v-13a13,13,0,0,1,11.26,19.5Z"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 76.27,
    y1: 98.37,
    x2: 97.73,
    y2: 98.37
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 76.27,
    y1: 103.37,
    x2: 97.73,
    y2: 103.37
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 76.27,
    y1: 108.37,
    x2: 97.73,
    y2: 108.37
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpCatalogPresentationIcon);
export default __webpack_public_path__ + "static/media/CP-catalog-presentation-icon.fdf279aed2635493d5a95444bfea4bd4.svg";
export { ForwardRef as ReactComponent };